const removeExtraSpaces = (val: string) => {
  return val.replace(/\s+/g, " ").trim();
};

// Workaround function to not use 'replaceAll' to mantain usability at older browsers.
// Does NOT work EXACTLY like 'replaceAll' so use with caution.
const replaceAll = (val: string, partToReplace: string, replaceWith: string) => {
  return val.split(partToReplace).join(replaceWith);
};

const specialCharacterSafeStartCase = (val: string) => {
  return val.replace(/\w\S*/g, word => {
    return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
  });
};

const countOccurrences = (str: string, valueToFind: string) => {
  const regExp = new RegExp(valueToFind, "gi");
  return (str.match(regExp) || []).length;
}

const StringUtils = {
  removeExtraSpaces,
  replaceAll,
  specialCharacterSafeStartCase,
  countOccurrences
};

export default StringUtils;
